export const setWithExpiry = (key, value, ttl) => {
    const now = new Date().getTime();
    const item = {
        value: value,
        expiry: now + ttl, // Define o tempo de expiração
    };
    localStorage.setItem(key, JSON.stringify(item)); // Armazena o item com a expiração no localStorage
};

export const getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
        return null; // Se o item não existe, retorna null
    }

    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    if (now > item.expiry) {
        localStorage.removeItem(key); // Se o item expirou, remove-o do localStorage
        return null; // Retorna null, já que o item expirou
    }

    return item.value; // Retorna o valor, caso não tenha expirado
};
